import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import TestimonialModal from './Components/TestimonialModal';

export default function AdminTestimonials()
{
    const [
        testimonials,
        setTestimonials
    ] = useState<any[]>([]);

    const [
        modalOpen,
        setModalOpen
    ] = useState(false);

    const [
        selectedTestimonial,
        setSelectedTestimonial
    ] = useState<any>(null);

    const loadTestimonials =
        async () =>
        {
            const response =
                await api.get(
                    '/testimonials'
                );

            setTestimonials(
                response.data
            );
        };

    useEffect(() => {

        loadTestimonials();

    }, []);

    const handleSave =
        async (
            data: any
        ) =>
        {
            if (
                selectedTestimonial
            )
            {
                await api.put(
                    `/testimonials/${selectedTestimonial.id}`,
                    data
                );
            }
            else
            {
                await api.post(
                    '/testimonials',
                    data
                );
            }

            setModalOpen(
                false
            );

            setSelectedTestimonial(
                null
            );

            loadTestimonials();
        };

    const handleDelete =
        async (
            id: number
        ) =>
        {
            if (
                !window.confirm(
                    'Delete this testimonial?'
                )
            ) {
                return;
            }

            await api.delete(
                `/testimonials/${id}`
            );

            loadTestimonials();
        };

    const moveUp =
        async (
            index: number
        ) =>
        {
            if (
                index === 0
            ) {
                return;
            }

            const updated =
                [...testimonials];

            [
                updated[index],
                updated[index - 1]
            ] = [
                updated[index - 1],
                updated[index]
            ];

            setTestimonials(
                updated
            );

            await api.post(
                '/testimonials/reorder',
                {
                    testimonials:
                        updated.map(
                            (
                                testimonial,
                                position
                            ) => ({
                                id:
                                testimonial.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            loadTestimonials();
        };

    const moveDown =
        async (
            index: number
        ) =>
        {
            if (
                index >=
                testimonials.length - 1
            ) {
                return;
            }

            const updated =
                [...testimonials];

            [
                updated[index],
                updated[index + 1]
            ] = [
                updated[index + 1],
                updated[index]
            ];

            setTestimonials(
                updated
            );

            await api.post(
                '/testimonials/reorder',
                {
                    testimonials:
                        updated.map(
                            (
                                testimonial,
                                position
                            ) => ({
                                id:
                                testimonial.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            loadTestimonials();
        };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>

                    Testimonials

                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedTestimonial(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >

                    Add Testimonial

                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Place
                    </th>

                    <th>
                        Rating
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {

                    testimonials.map(

                        (
                            testimonial,
                            index
                        ) => (

                            <tr
                                key={
                                    testimonial.id
                                }
                            >

                                <td>

                                    {
                                        testimonial.name
                                    }

                                </td>

                                <td>

                                    {
                                        testimonial.place
                                    }

                                </td>

                                <td>

                                    {

                                        testimonial.rating

                                    } / 5

                                </td>

                                <td>

                                    {

                                        testimonial.is_active

                                            ?

                                            'Yes'

                                            :

                                            'No'

                                    }

                                </td>

                                <td>

                                    <div className="actions">

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveUp(
                                                    index
                                                )
                                            }
                                        >
                                            ▲
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() =>
                                                moveDown(
                                                    index
                                                )
                                            }
                                        >
                                            ▼
                                        </button>

                                        <button
                                            className="edit-btn"
                                            onClick={() => {

                                                setSelectedTestimonial(
                                                    testimonial
                                                );

                                                setModalOpen(
                                                    true
                                                );

                                            }}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="delete-btn"
                                            onClick={() =>
                                                handleDelete(
                                                    testimonial.id
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </td>

                            </tr>

                        )

                    )

                }

                </tbody>

            </table>

            {

                modalOpen && (

                    <TestimonialModal

                        testimonial={
                            selectedTestimonial
                        }

                        onClose={() =>
                            setModalOpen(
                                false
                            )
                        }

                        onSave={
                            handleSave
                        }

                    />

                )

            }

        </AdminLayout>

    );
}
